import { render, staticRenderFns } from "./IdCollectThankyou.vue?vue&type=template&id=389f45ae"
import script from "./IdCollectThankyou.vue?vue&type=script&lang=js"
export * from "./IdCollectThankyou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports